import type { TeoText } from '@/teoCore/text/TeoText';
import { ReactiveValue } from '@/utils/reactive-value/reactive-value';

export class BrandfitManager {
  private teoText: TeoText;

  selectedMarker = new ReactiveValue<string | undefined>(undefined);
  constructor(teoText: TeoText) {
    this.teoText = teoText;
    this.selectedMarker.set('hello' + Math.random());
  }
}
